<script setup lang="ts">
import { computed } from "vue";
import { useOperationStore } from "@/stores/operation";

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
</script>
<template>
  <div
    class="mentions box-border p-3 text-primary-text text-[.95em] leading-[1.4em]"
  >
    <div>
      <div>
        <p class="step w-full font-semibold text-center py-[2em] text-[1.4em]">
          {{ $t("mentions.title") }}
        </p>
        <div class="pb-4">
          <div
            v-if="
              op?.custom?.responsable_info &&
              op?.custom?.responsable_info != '<div><br></div>'
            "
          >
            <div v-html="op?.custom?.responsable_info" />
          </div>
          <div class="text-center" v-else>
            <div v-html="$t('mentions.bloc1')" />
          </div>

          <div class="text-center py-4">
            <div v-html="$t('mentions.bloc2')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
